export default __webpack_public_path__ + "static/media/time.23cd0054.svg";